import { Link } from "react-router-dom";
import { StepHeading } from "@/components/booking/OptionCard";
import { TIME_SLOTS } from "@/data/content";
import { inputCls, labelCls } from "@/lib/booking";

export function StepSchedule({ form, set, minDate, blocked }) {
  return (
    <div>
      <StepHeading title="When suits you?" />
      <div className="mt-6">
        <label className={labelCls}>Preferred date *</label>
        <input type="date" min={minDate} data-testid="booking-date" className={inputCls} value={form.date} onChange={(e) => set({ date: e.target.value })} />
        {form.date && blocked.includes(form.date) && (
          <p className="mt-2 text-sm text-red-700">That date is fully booked - please choose another.</p>
        )}
        {!form.extras.includes("same-day") && (
          <p className="mt-2 text-xs text-faint">Need a clean today? Add "Same-day / urgent booking" in extras.</p>
        )}
      </div>
      <div className="mt-6">
        <label className={labelCls}>Preferred arrival window *</label>
        <div className="grid gap-3 sm:grid-cols-3">
          {TIME_SLOTS.map((t) => (
            <button
              key={t.value}
              type="button"
              data-testid={`booking-slot-${t.value}`}
              onClick={() => set({ time_slot: t.value })}
              className={`rounded-2xl border px-4 py-4 text-center transition-all duration-300 ${
                form.time_slot === t.value ? "border-blue bg-blue text-canvas" : "border-subtle bg-canvas hover:border-sage"
              }`}
            >
              <p className="text-sm font-semibold">{t.label}</p>
              <p className={`mt-1 text-[11px] ${form.time_slot === t.value ? "text-canvas/70" : "text-faint"}`}>{t.hint}</p>
            </button>
          ))}
        </div>
      </div>
      <p className="mt-6 rounded-2xl border border-sage/40 bg-sage-light/50 p-5 text-sm leading-relaxed text-body" data-testid="booking-schedule-note">
        This is your preferred date and arrival window, not a guaranteed exact arrival time. HOMELARA will confirm your
        exact appointment time with you after booking.
      </p>
    </div>
  );
}

const FIELDS = [
  ["name", "Full name *", "Your name", "text", false],
  ["email", "Email *", "you@example.com", "email", false],
  ["phone", "Mobile number *", "+44 ...", "tel", false],
  ["postcode", "Postcode *", "e.g. N1 9GU", "text", false],
  ["address", "Full property address *", "Flat / house number, street, London", "text", true],
];

export function StepDetails({ form, set }) {
  return (
    <div>
      <StepHeading title="Your details." hint="We currently serve London Zones 1 & 2. We'll review your postcode and contact you if anything needs checking." />
      <div className="mt-6 grid gap-5 sm:grid-cols-2">
        {FIELDS.map(([k, label, ph, type, wide]) => (
          <div key={k} className={wide ? "sm:col-span-2" : ""}>
            <label className={labelCls}>{label}</label>
            <input type={type} data-testid={`booking-${k}`} className={inputCls} value={form[k]} onChange={(e) => set({ [k]: e.target.value })} placeholder={ph} />
          </div>
        ))}
        <div className="sm:col-span-2">
          <label className={labelCls}>Access instructions</label>
          <textarea rows={3} data-testid="booking-access" className={inputCls} value={form.access_instructions} onChange={(e) => set({ access_instructions: e.target.value })} placeholder="Entry codes, concierge, where to find keys..." />
        </div>
        <div className="sm:col-span-2">
          <label className={labelCls}>Additional notes</label>
          <textarea rows={3} data-testid="booking-notes" className={inputCls} value={form.notes} onChange={(e) => set({ notes: e.target.value })} placeholder="Pets, priorities, anything we should know..." />
        </div>
      </div>
      <label className="mt-6 flex cursor-pointer items-start gap-3 text-sm leading-relaxed text-body">
        <input
          type="checkbox"
          checked={form.terms_accepted}
          onChange={(e) => set({ terms_accepted: e.target.checked })}
          data-testid="booking-terms-checkbox"
          className="mt-0.5 h-4 w-4 shrink-0 accent-[#0F2942]"
        />
        <span>
          I accept HOMELARA's{" "}
          <Link to="/legal/terms-and-conditions" target="_blank" data-testid="booking-terms-link" className="text-blue underline underline-offset-4">
            Terms &amp; Conditions
          </Link>
          .
        </span>
      </label>
    </div>
  );
}
